import { z } from "zod";
import { responseSchema } from "../http.js";
import { priceCentsSchema } from "./product.js";
import { FRANCHISE_PRICE_CENTS } from "./checkout.js";
/**
 * ═══════════════════════════════════════════════════════════
 * Franquicias — el directorio del panel y su configuración
 *
 * Réplica de `admin/franchises` y `admin/franchise-settings` (Anahí,
 * 27-ago). El directorio se DERIVA: franquiciatario es quien tiene
 * `becameFranchiseeAt` (lo escribe la validación de su orden), y su
 * tienda sale del módulo de tiendas. Aquí no se guarda una segunda
 * lista que pueda desincronizarse.
 *
 * La configuración sí es un documento: el PRECIO de la franquicia por
 * moneda y su vigencia. Editarla cambia lo que la landing ENSEÑA y lo
 * que el checkout COBRA de ahí en adelante (14-sep-2026: la landing y el
 * link de pago la leen del endpoint público; antes leían una constante y
 * el admin cambiaba un precio que nadie veía) — las órdenes ya creadas
 * conservan su total, como todo lo histórico.
 *
 * La "reserva de comisión" ($2,700 de la leyenda de «incluye
 * franquicia») se QUITÓ el 14-sep-2026 junto con el bono directo de
 * franquicia: sin bono que pagar, no hay nada que reservar.
 * ═══════════════════════════════════════════════════════════
 */
export const adminFranchiseItemSchema = z.object({
    userId: z.string(),
    name: z.string(),
    email: z.string(),
    phone: z.string().optional(),
    franchiseeSince: z.iso.datetime(),
    /** Su tienda personalizada, si ya la abrió. */
    storeSlug: z.string().nullable(),
    storeName: z.string().nullable(),
});
/** Búsqueda por nombre/correo y paginación, en el servidor. */
export const adminFranchisesQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    perPage: z.coerce.number().int().min(1).max(100).default(24),
    query: z.string().trim().max(120).optional(),
});
export const adminFranchiseListResponseSchema = responseSchema(z.object({
    items: z.array(adminFranchiseItemSchema),
    total: z.number().int().min(0),
    page: z.number().int().min(1),
    perPage: z.number().int().min(1),
}));
export const franchiseSettingsInputSchema = z.object({
    priceMXNCents: priceCentsSchema,
    priceUSDCents: priceCentsSchema,
    /** La vigencia que compra el pago: hoy, un año. */
    durationMonths: z.number().int().min(1).max(60),
});
export const franchiseSettingsSchema = franchiseSettingsInputSchema.extend({
    updatedAt: z.iso.datetime(),
});
/** La semilla: los valores que hoy viven como constantes del contrato. */
export const DEFAULT_FRANCHISE_SETTINGS = {
    priceMXNCents: FRANCHISE_PRICE_CENTS.MXN,
    priceUSDCents: FRANCHISE_PRICE_CENTS.USD,
    durationMonths: 12,
};
/** El precio por moneda, en la forma que usan la landing y el checkout. */
export function franchisePricesOf(settings) {
    return { MXN: settings.priceMXNCents, USD: settings.priceUSDCents };
}
export const franchiseSettingsResponseSchema = responseSchema(z.object({ settings: franchiseSettingsSchema }));
export const FRANCHISE_ADMIN_ROUTES = {
    list: "/api/admin/franchises",
    settings: "/api/admin/franchise-settings",
};
/** Lo que la tienda pública necesita: precio y vigencia. Sin sesión. */
export const FRANCHISE_ROUTES = {
    publicSettings: "/api/franchise-settings",
};
//# sourceMappingURL=franchise.js.map